import {
  BrainCircuit,
  Building2,
  CreditCard,
  FileText,
  LayoutDashboard,
  Mic,
  Users,
  type LucideIcon,
} from "lucide-react";

export type ServiceNavigationItem = {
  href: string;
  label: string;
  icon: LucideIcon;
};

export const serviceNavigationItems: readonly ServiceNavigationItem[] = [
  { href: "/dashboard", label: "대시보드", icon: LayoutDashboard },
  { href: "/resumes", label: "내 이력서", icon: FileText },
  { href: "/companies", label: "지원 회사", icon: Building2 },
  { href: "/analyses", label: "AI 서류 심사", icon: BrainCircuit },
  { href: "/interviews", label: "면접 연습", icon: Users },
  { href: "/cover-letter", label: "음성 자소서", icon: Mic },
  { href: "/subscription", label: "구독 관리", icon: CreditCard },
] as const;

export function isServiceNavigationActive(
  location: string,
  href: string,
): boolean {
  return location === href || location.startsWith(`${href}/`);
}
